import React, { useState, useEffect, useRef } from 'react';
import { BaseContext } from './contexts';
import Bau from './concepts/bau';
import BauImage from './concepts/bauImage';
import ConceptCarousel from './concepts/conceptCarousel';
import ConceptList from './concepts/conceptList';
import { mainPlan, plansList } from './data';
import { scrollTop } from './helper';
import {
  statInitialData,
  statSendData,
  selectMainPlan, selectOtherPlan, clickBack, plansPageScroll, checkPlanViewed
} from './statistics';

const Concept = ({ conceptName }) => {
  switch (conceptName) {
    case 'bau':
      return <Bau />;
    case 'bau_image':
      return <BauImage />;
    case 'concept_carousel':
      return <ConceptCarousel />;
    case 'concept_list':
      return <ConceptList />;
    default:
      return null;
  }
};

const App = ({ conceptName, set }) => {
  const [ page, setPage ] = useState("landing");
  const [ pages, setPages ] = useState([ page ]);

  const elRef = useRef(null);
  const plansLastElRef = useRef(null);
  const scrollPlansEls = useRef({});

  useEffect(() => {
    statInitialData();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', plansPageScroll(plansLastElRef, scrollPlansEls));
  }, []);

  useEffect(() => {
    if (elRef.current) {
      scrollTop();
    }
  }, [ page ]);

  useEffect(() => {
    if (elRef.current) {
      scrollTop();
    }
  }, [ page ]);

  const onBack = () => {
    clickBack(page);
    let foundIndex;
    const pagesLen = pages.length;
    for (let i = 1; pagesLen - i >= 0 && typeof foundIndex === 'undefined'; i++) {
      const curIndex = pagesLen - i;
      if (pages[curIndex] === page) {
        foundIndex = curIndex;
      }
    }
    const prevIndex = foundIndex - 1;
    if (prevIndex >= 0) {
      setPage(pages[prevIndex]);
      pages.pop();
      setPages([ ...pages ]);
    }
  };

  const conceptMainPlan = mainPlan(conceptName);
  const conceptPlansList = plansList(conceptName);

  const onFinish = () => {
    statSendData({ set });
    setPage(null);
  };

  const onSelectMainPlan = () => {
    selectMainPlan(conceptMainPlan);
    onFinish();
  };

  const onSelectPlan = (plan) => {
    selectOtherPlan(plan);
    onFinish();
  };

  const addElementToScrollablePlan = (plan) => (el) => {
    if (el) {
      scrollPlansEls.current[plan.id] = el;
      checkPlanViewed(plan.id, el);
    }
  };

  const value = {
    page,
    onBack,
    onSelectMainPlan,
    onSelectPlan,
    mainPlan: conceptMainPlan,
    plans: conceptPlansList,
    setPage: (pageName) => {
      pages.push(pageName);
      setPages([ ...pages ]);
      setPage(pageName);
    },
    plansLastElRef,
    scrollPlansEls,
    addElementToScrollablePlan
  };

  return (
    <BaseContext.Provider value={ value }>
      { !page ? (<></>) : (<Concept conceptName={ conceptName } />) }
      <div ref={ elRef } />
    </BaseContext.Provider>
  );
};

export default App;
